import { render } from "./PhotosLayer.vue?vue&type=template&id=30469f74"
import script from "./PhotosLayer.vue?vue&type=script&lang=js"
export * from "./PhotosLayer.vue?vue&type=script&lang=js"

import "./PhotosLayer.vue?vue&type=style&index=0&id=30469f74&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__